import { Button, Card, Col, Flex, Row, Typography, Space, notification, theme } from 'antd';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { BUTTON, TEXT } from '../../../layout/style';
import AuthRestAPI from '../../../restAPI/AuthRestAPI';

const { Text, Title } = Typography;

export default function OtpOptions() {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedOptionForMobile, setSelectedOptionForMobile] = useState(null);

  const [api, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = (type, message, description, placement) => {
    api[type]({
      message: message,
      description: description,
      placement
    });
  };

  const {
    token: {
      colorBgContainer,
      borderRadiusLG,
      colorPrimary,
      colorPrimaryBorder,
      colorTextDescription,
      colorBorder,
      fontSizeSM,
      colorError,
      colorBgElevated,
      colorBorderSecondary,
      colorTextSecondary,
      colorWarning,
    },
  } = theme.useToken();
  const [token, setToken] = useState();
  const [mobiles, setMobiles] = useState('');
  const [email, setEmail] = useState('');
  const [maskedEmail, setMaskedEmail] = useState('');
  const [selectedMobile, setSelectedMobile] = useState('');

  const handleSelectOption = (value) => {
    const parts = value.split("-");
    setSelectedOptionForMobile(value);
    setSelectedOption(parts[0]);
    setSelectedMobile(parts[1]);
  };

  const getTwoFactorAuthenticationData = React.useCallback(async (companyId, token) => {
    await AuthRestAPI.getTwoFactorStatus(companyId, token).then((res) => {
      if (res?.data) {
        setMobiles(res.data.phone);
        setEmail(res.data.email);

        // Mask email: use***@example.com
        const email = res.data.email;
        const atIdx = email.indexOf('@');
        let maskedEmail = email;
        if (atIdx > 3) {
          maskedEmail =
            email.slice(0, 3) +
            '*'.repeat(atIdx - 3) +
            email.slice(atIdx);
        }
        setMaskedEmail(maskedEmail);
      }
    }).catch(err => {
      console.log("error getting email :", err.message);
    })
  }, [location.state, location.pathname, navigate]);

  useEffect(() => {
    if (location?.state?.token) {
      const { token } = location.state;      
      setToken(token);
      getTwoFactorAuthenticationData(null, token);

      // clear the history
      navigate(location.pathname, {
        replace: true,
        state: null
      })
    }
  }, [getTwoFactorAuthenticationData,location.state, location.pathname, navigate]);

  const maskMobile = (phone) => {
    const masked =
      phone && phone.length > 4
        ? phone.slice(0, -4).replace(/./g, 'x') + phone.slice(-4)
        : phone;
    return masked;
  }

  const handleContinue = async () => {

    try {
      let value = null;
      if (selectedOption === 'sms') {
        value = selectedMobile;
      } else if (selectedOption === 'email') {
        value = email;
      }

      const formData = {
        "method": selectedOption,
        "value": value
      };
      await AuthRestAPI.requestOtpforTwoFactor(formData, null, token)
        .then((response) => {
          openNotificationWithIcon("success", "Successful", `${response.message}`, "bottomLeft");
        })
        .catch((err) => {
          if (err.response) {
            openNotificationWithIcon("error", "Two-Factor authentication OTP request failed", `${err.response.data.message}`, "bottomLeft");
          } else {
            openNotificationWithIcon("error", "Two-Factor authentication OTP request failed", `${err.message}`, "bottomLeft");
          }
        });
       navigate('/verify-otp', {
         state: { 
          method: selectedOption, 
          value: value,
          token: token
         } 
        });
    } catch (error) {
      console.log('Error in request otp :', error)
    }
  };

  return (
    <div>
      {contextHolder}
      <Row>
        <Col>
          <Title level={2} style={TEXT.heading1}>Select OTP Delivery Method</Title>
          <Text type="secondary">
            Welcome back to OCTOPLEX, your all-in-one board meeting and workflow management solution.
            <br />
            Select your preferred method to receive a one-time password (OTP).
          </Text>
          <br /><br />
        </Col>
      </Row>

      <Row gutter={[16, 16]}>
        {email !== null ? (
          <Col xs={24} md={8}>
            <Card
              hoverable
              onClick={() => handleSelectOption('email-0')}
              style={{
                borderRadius: borderRadiusLG,
                border: selectedOption === 'email' ? `2px solid ${colorPrimary}` : undefined,
                minHeight: '130px',
              }}
            >
              <Flex vertical align="start" gap={0}>
                <Title level={5}>Send via Email</Title>
                <Text type="secondary">
                  We'll send a 6-digit OTP to <b>{maskedEmail}</b>
                </Text>
              </Flex>
            </Card>
          </Col>
        ) : (
          <Col xs={24}>
            <Text type="secondary">No email available.</Text>
          </Col>
        )}
        {Array.isArray(mobiles) && mobiles.length > 0 ? (
          mobiles.map((phone, index) => (
            <Col xs={24} md={8} key={`sms-${phone}`}>
              <Card
                hoverable
                onClick={() => handleSelectOption(`sms-${phone}`)}
                style={{
                  borderRadius: borderRadiusLG,
                  border: selectedOptionForMobile === `sms-${phone}` ? `2px solid ${colorPrimary}` : undefined,
                  minHeight: '140px',
                }}
              >
                <Flex vertical align="start" gap={0}>
                  <Title level={5}>Send via SMS</Title>
                  <Text type="secondary">
                    We'll send a 6-digit OTP to <b>{maskMobile(phone) || 'Loading...'}</b>
                  </Text>
                </Flex>
              </Card>
            </Col>
          ))
        ) : (
          <Col xs={24}>
            <Text type="secondary">No phone numbers available.</Text>
          </Col>
        )}

      </Row>

      <br />
      <Flex justify="flex-start" gap={16}>
        <Button type="default" style={BUTTON.primary} onClick={() => navigate('/login')}>
          Back to Login
        </Button>
        <Button
          type="primary"
          style={BUTTON.primary}
          onClick={handleContinue}
          disabled={!selectedOption}
        >
          Continue
        </Button>
      </Flex>
    </div>
  );
}
